import React from 'react'
import UnitGroupSelection from './UnitGroupSelection'
import { scaleTime } from 'd3-scale'
import { createMeasurement, Graph, Scatter } from 'integ-graphs'
import { timeFormat, timeParse } from 'd3-time-format'
import { getUnitMap } from 'analytics/selectors'
import { retrieveGadsMonthlyByGroup, retrieveGadsMonthlyByUnit } from '../actions'
import { getGadsMonthlyData } from '../selectors'

import { connect } from 'react-redux'
import { fromNullable } from 'data.maybe'

const xValGetter = ({ date }) => timeParse('%Y-%m-%d')(date)

const measurement = createMeasurement({
  margin: { top: 20, right: 60, bottom: 40, left: 70 },
})

const TrendChart = ({ data, spec: { display, id }, retrieveByUnit, retrieveByGroup, unitMap }) => [
  <UnitGroupSelection key="selection" {...{ retrieveByGroup, retrieveByUnit }} single />,
  <h3 key="title">
    {fromNullable(data[0])
      .map(d => unitMap[d.unitId] || d.unitId)
      .getOrElse('')}
    {display}
  </h3>,
  <Graph key="scatter-graph" measurement={measurement}>
    <Scatter
      data={data}
      measurement={measurement}
      xScale={scaleTime()}
      defaultRadius={4}
      useXDataMin
      useYDataMin
      xValGetter={xValGetter}
      yValKey={id}
      xFormat={timeFormat('%b %Y')}
      showLinearRegression
    />
  </Graph>,
]
// circleRenderer={props => (
//   <Circle {...props}>
//     <title>{unitMap[props.data.unitId] || props.data.unitId}</title>
//   </Circle>
// )}

const mapStateToProps = state => ({
  data: getGadsMonthlyData(state),
  unitMap: getUnitMap(state),
})

export default connect(mapStateToProps, {
  retrieveByGroup: retrieveGadsMonthlyByGroup,
  retrieveByUnit: retrieveGadsMonthlyByUnit,
})(TrendChart)
